import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { PRACTICE_SETTINGS_CONSULT_TIMES } from "api/Service";

export const CONSULT_TIMES_QUERY_KEY = "consultTimes";

export const useConsultTimes = () => {
  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: [CONSULT_TIMES_QUERY_KEY, tenantVal],
    queryFn: async () => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.get(
        `${tenantVal}${PRACTICE_SETTINGS_CONSULT_TIMES}`
      );
      const raw = Array.isArray(response.data) ? response.data : [];

      return raw
        .map((value) => {
          const minutes = Number.parseInt(value, 10);
          if (!Number.isInteger(minutes) || minutes <= 0) {
            console.warn(
              `[useConsultTimes] dropping invalid duration entry: ${value}`
            );

            return null;
          }

          return minutes;
        })
        .filter((minutes) => minutes !== null);
    },
    enabled: !!tenantVal,
    staleTime: 5 * 60 * 1000,
  });
};
